import PosthogService from '~/services/posthog/PosthogService';

/**
 * Fires when a user opens the Saltclick chatbot from the Help page.
 * Saltclick renders its own button, so we hook the Embedded Messaging
 * conversation-opened event as the closest signal to a button tap.
 * Event: dental_portal:help:chatbot_button_tapped
 */
export function fireHelpChatbotButtonTapped(): void {
  PosthogService.getInstance().track('dental_portal:help:chatbot_button_tapped', {
    user_type: 'office',
    flag_enabled: true,
  });
}
